export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "betsportnamibia-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "betsportnamibia-themeWrapLive" */'./LiveThemeImporter'),
  },
};
